import ApiService from '@/core/services/ApiService';
import { Actions, Mutations } from '@/store/enums/StoreEnums';
import { Module, Action, Mutation, VuexModule } from 'vuex-module-decorators';

export interface MetatagsObject {
  id: number;
  titleEn: string;
  titleAr: string;
  descEn: string;
  descAr: string;
  screen: string;
  isActive: boolean;
}

export interface MetatagsListInfo {
  totalItems: number;
  currentPage: number;
  pageSize: number;
  isNext: boolean;
  previous: number;
  metatagss: Array<MetatagsObject>;
  errors: unknown;
}

@Module
export default class MetatagssModule
  extends VuexModule
  implements MetatagsListInfo
{
  metatagss = [] as Array<MetatagsObject>;
  totalItems = 0;
  currentPage = 1;
  pageSize = 10;
  previous = 0;
  isNext = true;
  errors = {};

  /**
   * Get metatagss list
   * @returns Array<MetatagsObject>
   */
  get metatagssList(): Array<MetatagsObject> {
    return this.metatagss;
  }

  /**
   * Get total items
   * @returns number
   */
  get metatagssListCount(): number {
    return this.totalItems;
  }

  @Mutation
  [Mutations.SET_METATAGS](data) {
    this.metatagss = data.data;
    this.totalItems = data.totalItems;
    this.currentPage = data.currentPage;
    this.pageSize = data.pageSize;
    this.isNext = data.isNext;
    this.previous = data.previous;
    this.errors = {};
  }

  @Mutation
  [Mutations.SET_METATAG_CURRENT_PAGE](page) {
    this.currentPage = page;
  }

  @Mutation
  [Mutations.RESET_METATAGS_LIST]() {
    this.metatagss = [] as Array<MetatagsObject>;
    this.totalItems = 0;
    this.currentPage = 1;
    this.pageSize = 10;
    this.previous = 0;
    this.isNext = true;
    this.errors = {};
  }

  @Action
  [Actions.CREATE_METATAG](data) {
    ApiService.setAuthorizationHeader();
    return ApiService.post('/metatags', data)
      .then(() => {
        this.context.commit(Mutations.RESET_METATAGS_LIST);
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_ERROR, {
          [response.statusText]: [response.data.message],
        });
      });
  }

  @Action
  [Actions.DELETE_METATAG](id) {
    ApiService.setAuthorizationHeader();
    return ApiService.delete('/metatags', id)
      .then(() => {
        this.context.commit(Mutations.RESET_METATAGS_LIST);
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_ERROR, {
          [response.statusText]: [response.data.message],
        });
      });
  }

  @Action
  [Actions.UPDATE_METATAG]({ id, data }) {
    ApiService.setAuthorizationHeader();
    return ApiService.update('/metatags', id, data)
      .then(() => {
        this.context.commit(Mutations.RESET_METATAGS_LIST);
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_ERROR, {
          [response.statusText]: [response.data.message],
        });
      });
  }

  @Action
  [Actions.UPDATE_METATAG_CURRENT_PAGE](val) {
    this.context.commit(Mutations.SET_METATAG_CURRENT_PAGE, val);
  }

  @Action
  [Actions.GET_METATAG](id) {
    ApiService.setAuthorizationHeader();
    return ApiService.get('/metatags', id);
  }

  @Action
  [Actions.GET_METATAGS]() {
    ApiService.setAuthorizationHeader();
    return ApiService.query('/metatags', {
      params: { page: this.currentPage },
    })
      .then(({ data }) => {
        this.context.commit(Mutations.SET_METATAGS, data);
      })
      .catch(({ response }) => {
        console.error(response);
        // this.context.commit(Mutations.SET_ERROR, {
        //   [response.statusText]: [response.data.message],
        // });
      });
  }
}
